import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the CoHtmlStringStripperPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'htmlStringStripper',
})
export class CoHtmlStringStripperPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, cutoff?: number) {
    if (!value || value === null || value === '') return '';
    let str = value.replace(/<\/?[\w\s]*>|<.+[\W]>/g, "");
    if (!cutoff || str.length <= cutoff) return str;
    return `${str.slice(0, cutoff)}...`
  }
}



// WEBPACK FOOTER //
// ./src/pipes/co-html-string-stripper/co-html-string-stripper.ts